import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkExtension'
})
export class CheckExtensionPipe implements PipeTransform {

  transform(value: string, ...args: any[]): unknown {
		if (!value) {
			return false;
	    }
	  	if(args.length > 1 && (args[1]== 'NOT' || args[1]== 'not'))
	  		return !value.toLowerCase().endsWith(('.'+args[0].toLowerCase()));
	  	else
	    	return value.toLowerCase().endsWith(('.'+args[0].toLowerCase()));
  }

}
